// Single place that touches import.meta.env. Cast keeps this file compiling
// whether or not vite/client types are wired up by the build config.
const viteEnv =
  ((import.meta as unknown as { env?: Record<string, string | undefined> })
    .env as Record<string, string | undefined>) || {};

// Vite substitutes DEV at build time, so dev-only surfaces can default off in a production bundle.
export const IS_DEV_BUILD: boolean = Boolean(viteEnv.DEV);

export function readEnv(key: string): string | undefined {
  const value = viteEnv[key];
  return value === undefined || value === '' ? undefined : value;
}

export function readEnvNumber(key: string, fallback: number): number {
  const raw = readEnv(key);
  if (!raw) return fallback;
  const parsed = Number(raw);
  return isNaN(parsed) ? fallback : parsed;
}
